const e = "styles-module__column___V1GIQ", t = "styles-module__title___fs7-c", s = "styles-module__value___Freum", _ = "styles-module__description___A-ekc", l = {
  column: e,
  title: t,
  value: s,
  description: _
};
export {
  e as column,
  l as default,
  _ as description,
  t as title,
  s as value
};
